// API Configuration
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? '' // Use relative URLs in production (same domain as frontend)
  : 'http://localhost:8000'; // Use localhost in development

console.log('🔍 Environment:', process.env.NODE_ENV);
console.log('🔍 REACT_APP_API_BASE_URL:', process.env.REACT_APP_API_BASE_URL);
console.log('🔍 Final API_BASE_URL:', API_BASE_URL);

export { API_BASE_URL };
